<div class="report row mx-md-0 px-md-0">
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Client ID:</span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.customerId }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Client:</span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.customerName }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-2 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Phone No.:</span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.customerPhone1 }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-3 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Loan Type:</span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.productName | product }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-4 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Date Taken: </span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.dateTaken }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-5 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Time Taken: </span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.timeTaken }}
        </span>
      </div>
    </div>
  </div>
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Amount Taken:</span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.loanAmountTaken | number }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Int. Expected:</span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.InterestExpected | number }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-2 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Int + Loan Paid:</span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.InterestPaid | number }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-3 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Interest Left:</span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.InterestRemain | number }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-4 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Loan Aging:</span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated"> {{ itm.loanAging }} Day(s) </span>
      </div>
    </div>
  </div>
  <div class="field-5 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Interest Rate:</span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated"> {{ itm.interestRateUsed }}%  {{checkArmotCycle(itm.loanAmortCycle)}} </span>
      </div>
    </div>
  </div>
</div>
